module.exports = __webpack_public_path__ + "img/ojk-logo.fc116b16.webp";